<template>
  <InfoLayout
    v-if="!isMobile"
    :current-path="reverseFull({ name: 'ethical_commission' })"
    :is-policy="false"
  >
    <template #title>
      {{ t('Этический комитет', options) }}
    </template>
    <template #content>
      <EthicalCommissionContent
        :ethical-commissions="context.ethical_commission"
        :ethical-commission-meetings-count="context.ethical_commission_meetings_count"
        :ethical-commission-cases-count="context.ethical_commission_cases_count"
      />
    </template>
  </InfoLayout>
  <div v-else>
    <EthicalCommissionContent
      :ethical-commissions="context.ethical_commission"
      :ethical-commission-meetings-count="context.ethical_commission_meetings_count"
      :ethical-commission-cases-count="context.ethical_commission_cases_count"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ContextStore } from 'src/components/pages/info/ethical-commission/index/types'
import { useContextStore, useURLStore } from 'src/store'
import I18NextVue from 'i18next'
import EthicalCommissionContent from 'src/components/pages/info/ethical-commission/index/components/MainContent/MainContent.vue'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()

const isMobile = context.flavour === 'mobile'

const { reverseFull } = useURLStore()
</script>
